module.exports = __webpack_public_path__ + "img/LMS_LOGO_new.47e8a7b7.png";